import React from 'react';
import { NavLink } from 'react-router-dom';
import { makeStyles } from '@material-ui/core';

const NavItem = ({ to = '', linkText = '', component = null }) => {
  const classes = useStyles();

  return (
    <li className={classes.RightNavItem}>
      {component || (
        <NavLink
          to={to}
          exact
          className={classes.NavLinkStyle}
          activeClassName={classes.NavLinkActiveStyle}
        >
          {linkText}
        </NavLink>
      )}
    </li>
  );
};

export default NavItem;

const useStyles = makeStyles((theme) => ({
  RightNavItem: {
    color: '#000',
  },
  NavLinkStyle: {
    color: '#000',
    textDecoration: 'none',
    transition: 'color 0.3s ease-out',

    '&:hover, &:focus': {
      color: theme.palette.info.light,
    },
  },
  NavLinkActiveStyle: {
    fontWeight: 700,
    color: `${theme.palette.primary.main} !important`,
    pointerEvents: 'none',
    cursor: 'default',
  },
}));
